"use strict";

import { lcvCampaignConstants } from "../_constants/lcvCampaign.constants";

export const INITIAL_LCV_CAMPAIGN_STATE = {
     campaigns : [],
     selectedCampaignId : null,
     isLoaded : false,
};

// The selection is shared by every LCV screen, so moving from the prize pot to a report keeps the
// campaign the administrator chose. The backend lists the newest campaign first, and that is the one
// selected until someone picks another.
export function lcvCampaign(state = INITIAL_LCV_CAMPAIGN_STATE, action) {
    switch (action.type) {
     case lcvCampaignConstants.LCV_CAMPAIGNS_GET_COMPLETE: {
          const campaigns = action.payload?.campaigns || [];
          const isStillListed = campaigns.some((campaign) => campaign.id === state.selectedCampaignId);

          return {
               ...state,
               campaigns,
               selectedCampaignId: isStillListed ? state.selectedCampaignId : campaigns[0]?.id ?? null,
               isLoaded: true,
          };
     }
     case lcvCampaignConstants.LCV_CAMPAIGN_SELECT:
          return {
               ...state,
               selectedCampaignId: action.payload,
          };
     default:
          return state;
    }
}
